module.exports = __webpack_public_path__ + "img/2.1-九搂十八杈（杨树田-摄）.b73e3a53.jpg";